/**
 * Batch Management Components
 * Contains modal for adding batches (for coaching teachers)
 */
import React, { useState } from 'react';
import axios from 'axios';

/**
 * Add Batch Modal Component
 * Form for creating a new batch
 */
export const AddBatchModal = ({ onClose, onBatchAdded }) => {
  const [formData, setFormData] = useState({
    name: '',
    subject: '',
    grade: '',
    location: '',
    is_special: false
  });
  const [loading, setLoading] = useState(false);

  const subjects = ['Mathematics', 'Science', 'English', 'Computer', 'Hindi', 'Social Studies', 'Physics', 'Chemistry', 'Biology', 'Environmental Studies'];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post('/batches', {
        name: formData.name,
        subject: formData.subject,
        grade: parseInt(formData.grade),
        location: formData.location || null,
        is_special: formData.is_special
      });
      
      onBatchAdded();
      onClose();
    } catch (error) {
      console.error('Error creating batch:', error);
    }
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4">Create Batch</h2>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-blue-800 mb-1"><strong>Batch Name</strong></label>
            <input
              type="text"
              required
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              data-testid="batch-name-input"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-blue-800 mb-1"><strong>Subject</strong></label>
            <select
              required
              value={formData.subject}
              onChange={(e) => setFormData({...formData, subject: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              data-testid="batch-subject-select"
            >
              <option value="">Select Subject</option>
              {subjects.map(subject => (
                <option key={subject} value={subject}>{subject}</option>
              ))}
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-blue-800 mb-1"><strong>Grade</strong></label>
            <select
              required
              value={formData.grade}
              onChange={(e) => setFormData({...formData, grade: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              data-testid="batch-grade-select"
            >
              <option value="">Select Grade</option>
              {[...Array(12)].map((_, i) => (
                <option key={i + 1} value={i + 1}>Grade {i + 1}</option>
              ))}
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-blue-800 mb-1"><strong>Location (Optional)</strong></label>
            <input
              type="text"
              value={formData.location}
              onChange={(e) => setFormData({...formData, location: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              data-testid="batch-location-input"
            />
          </div>

          <label className="flex items-center gap-3 rounded-lg border border-orange-200 bg-orange-50 px-3 py-2 text-sm text-orange-900">
            <input
              type="checkbox"
              checked={formData.is_special}
              onChange={(e) => setFormData({ ...formData, is_special: e.target.checked })}
              className="h-4 w-4 text-orange-600 border-orange-300 rounded"
            />
            <span className="font-medium">Select if want to add students without creating login for parent/child. Links will be generated for accessing tasks. Student can use link to submit tasks for this batch.</span>
          </label>
          
          <div className="flex space-x-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 py-2 px-4 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
              data-testid="add-batch-submit"
            >
              {loading ? 'Creating...' : 'Create Batch'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
